

import { default as commonModule, LoggerService } from  './../common/common.module'

import { Api, ApiProvider } from './api.provider'
import { ApiResourceFactory } from './api.resource.factory'
import { LocalDictionaryFactory } from './api.local-dictionary.factory'
import { ApiHttpRequestInterceptorFactory } from './api.http-request-interceptor.factory'

import { IUserSession } from '../../helpers/user-session'

var moduleName = 'simax.api'
var module = angular.module(moduleName, [require('angular-resource'), commonModule])

module.factory('apiResource', ['$resource', ($resource: ng.resource.IResourceService) => new ApiResourceFactory($resource)])
module.factory('httpRequestInterceptor', ['$injector', ($injector: ng.auto.IInjectorService) => new ApiHttpRequestInterceptorFactory($injector)])
module.factory('localDictionary', ['api', 'logger', '$q', 'userSession', (api: Api, logger: LoggerService, $q: ng.IQService, userSession: IUserSession) => new LocalDictionaryFactory(api, logger, $q, userSession)])
module.provider('api', [() => new ApiProvider()])

module.config(['$httpProvider', ($httpProvider: ng.IHttpProvider) => {
    $httpProvider.interceptors.push('httpRequestInterceptor')
}])

export default moduleName
export { Api, ApiProvider, LocalDictionaryFactory }